import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

export function getAuthMenu(data) {
  return request({
    url: "apis/demo/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/users/signup/getLogin",
    method: "post",
    data
  });
}

export function signLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/login/iccec",
    method: "post",
    data
  });
}

export function getAppToken(data) {
  return request({
    url: "/apis/bid/oauth2/codeRedirect",
    method: "post",
    data
  });
}

// 帮助中心意见反馈
export function insertAppAdvice(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/insertAppAdvice",
    method: "POST",
    data
  });
}
